// @flow

import * as React from "react";
import s from "./ButtonToggle.scss";

type Props = {
  label: string,
  label1: string,
  label2: string,
  value1: string | number,
  value2: string | number,
  selected: string,
  name: string,
  onChange: (e: SyntheticEvent<any>) => void,
};

export const ButtonToggle = (props: Props) => {
  const { name, label, label1, label2, value1, value2, onChange, selected } = props;

  return (
    <div className={s.label}>
      {label}
      <div className={s.wrapper}>
        <input
          id="toggle-on"
          className={[s.toggle_left, s.toggle].join(" ")}
          name={name}
          value={value1}
          type="radio"
          defaultChecked={selected === value1}
          onChange={e => onChange(e)}
        />
        <label htmlFor="toggle-on" className={s.toggle_button}>
          {label1}
        </label>
        <input
          id="toggle-off"
          className={[s.toggle_right, s.toggle].join(" ")}
          name={name}
          value={value2}
          type="radio"
          defaultChecked={selected === value2}
          onChange={e => onChange(e)}
        />
        <label htmlFor="toggle-off" className={s.toggle_button}>
          {label2}
        </label>
      </div>
    </div>
  );
};

export default ButtonToggle;
